import { TabView, TabPanel } from "primereact/tabview";
import { useInventoryOverviewPage } from "./hooks/useInventoryOverviewPage";
import { ExpirationTab } from "./components/ExpirationTab";
import { QuantityTab } from "./components/QuantityTab";
import { OnboardingItemKey } from "../../../common/enums";
import { usePageGuide } from "../../onboarding/hooks/usePageGuide";
import styles from "./InventoryOverviewPage.module.scss";

const ExpirationTabHeader = () => (
  <span data-onboarding="inventory-overview-expiration-tab">По срок на годност</span>
);

const QuantityTabHeader = () => (
  <span data-onboarding="inventory-overview-stock-tab">По наличност</span>
);

export const InventoryOverviewPage = () => {
  const {
    activeTabIndex,
    setActiveTabIndex,
    canDestroy,
    expirationTab,
    quantityTab,
  } = useInventoryOverviewPage();

  usePageGuide(OnboardingItemKey.InventoryOverviewGuide);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1 className={styles.title}>Наличности</h1>
      </div>

      <div className={styles.tabs_wrapper}>
        <TabView
          activeIndex={activeTabIndex}
          onTabChange={(e) => setActiveTabIndex(e.index)}
          className={styles.root_tabs}
        >
          <TabPanel header={<ExpirationTabHeader />}>
            <ExpirationTab
              batches={expirationTab.batches}
              isLoading={expirationTab.isLoading}
              canDestroy={canDestroy}
              onDestroy={expirationTab.destroyBatch}
            />
          </TabPanel>
          <TabPanel header={<QuantityTabHeader />}>
            <QuantityTab
              products={quantityTab.products}
              isLoading={quantityTab.isLoading}
              hasLowStockItems={quantityTab.hasLowStockItems}
              onCreateTransfer={quantityTab.navigateToCreateTransfer}
            />
          </TabPanel>
        </TabView>
      </div>
    </div>
  );
};
